export const SITE_URL = "https://busgo.travel";

export const NEWS = [
    {
        slug: "autobuski-prevoz-u-srbiji-online-kupovina-karata",
        date: "2026-10-27",
        title: "Autobuski prevoz u Srbiji: prednosti online kupovine karata",
        seoTitle: "Autobuski prevoz u Srbiji - prednosti online kupovine karata | BusGo",
        seoDescription:
            "Autobuski prevoz u Srbiji uz online kupovinu karata: pregledajte polaske prevoznika Bortravel, Jadran Bus, Kanis Leskovac, Naisturs, Ozlem i Alenik na BusGo.",
        excerpt:
            "Kako online kupovina autobuskih karata štedi vreme, olakšava organizaciju puta i šta proveriti pre kupovine.",
        image: "/assets/news/autobuski-prevoz-u-srbiji-online-kupovina-karata.jpg",
        imageAlt: "Pretraga autobuskih polazaka na BusGo sajtu na laptopu",
        blocks: [
            {
                type: "p",
                text: "Autobuski prevoz povezuje gradove i mesta širom Srbije i predstavlja važan deo svakodnevnih putovanja. Bilo da putujete zbog posla, studiranja, posete porodici ili odmora, pravovremeno planiranje prevoza olakšava organizaciju puta. Online kupovina autobuskih karata omogućava da deo priprema završite putem telefona ili računara, bez odlaska na prodajno mesto.",
            },
            { type: "h2", text: "Jednostavnije planiranje putovanja autobusom" },
            {
                type: "p",
                text: "Prilikom organizacije puta važno je pronaći odgovarajući polazak i uskladiti ga sa svojim obavezama. Digitalne platforme za prodaju karata olakšavaju ovaj proces jer putnicima omogućavaju da pregledaju dostupnu ponudu za željenu relaciju i datum.",
            },
            {
                type: "p",
                text: "Na BusGO platformi nalaze se prevoznici Bortravel, Jadran Bus, Kanis Leskovac, Alenik, Naisturs, Ozlem i mnogi drugi. Njihova ponuda na jednom mestu olakšava pretragu i izbor među dostupnim polascima.",
            },
            { type: "h3", text: "Izbor polaska prema vašim potrebama" },
            {
                type: "p",
                text: "Vreme polaska, mesto ukrcavanja i uslovi putovanja predstavljaju važne informacije pri izboru prevoza. Pre kupovine proverite podatke za konkretan polazak kako biste odabrali opciju koja odgovara vašem planu puta.",
            },
            { type: "h2", text: "Koje su prednosti online kupovine autobuskih karata?" },
            {
                type: "p",
                text: "Kupovina karata putem interneta donosi više praktičnih prednosti, posebno kada želite da putovanje organizujete unapred i smanjite broj obaveza pred polazak.",
            },
            { type: "h3", text: "Ušteda vremena" },
            {
                type: "p",
                text: "Online kupovinom izbegavate poseban odlazak na šalter samo radi kupovine karte. Pretragu i kupovinu možete obaviti od kuće, iz kancelarije ili dok ste u pokretu, uz pristup internetu.",
            },
            { type: "h3", text: "Lakša organizacija puta" },
            {
                type: "p",
                text: "Kada kartu kupite unapred, jedan važan deo pripreme već je završen. To vam ostavlja više vremena za organizaciju dolaska do mesta ukrcavanja, pripremu prtljaga i druge obaveze.",
            },
            { type: "h3", text: "Pregled dostupne ponude" },
            {
                type: "p",
                text: "Pretraga putem interneta omogućava vam da pregledate dostupne polaske za izabrani datum. Tako lakše pronalazite termin koji možete da uskladite sa poslovnim sastankom, nastavom ili nastavkom putovanja.",
            },
            { type: "h2", text: "Šta proveriti pre kupovine karte?" },
            {
                type: "p",
                text: "Pre potvrde kupovine pažljivo proverite polazno i odredišno mesto, datum putovanja, vreme polaska i mesto ukrcavanja. Obratite pažnju i na uslove prevoznika koji se odnose na prtljag, otkazivanje i promenu karte.",
            },
            { type: "h3", text: "Pripremite kartu za ukrcavanje" },
            {
                type: "p",
                text: "Nakon kupovine pročitajte dobijenu potvrdu i uputstva za korišćenje karte. Proverite da li je dovoljno da kartu pokažete na telefonu ili je potrebno da je odštampate. Na mesto polaska dođite dovoljno rano kako biste imali vremena da pronađete autobus i pripremite se za ukrcavanje.",
            },
            { type: "h2", text: "Planirajte sledeće putovanje uz BusGO" },
            {
                type: "p",
                text: "Online kupovina autobuskih karata olakšava pripremu putovanja i štedi vreme. Uz ponudu prevoznika Bortravel, Jadran Bus, Kanis Leskovac, Naisturs, Ozlem i Alenik na BusGO platformi, pregledajte dostupne polaske, izaberite odgovarajući termin i kupite kartu za svoje sledeće putovanje.",
            },
            { type: "cta", text: "Pretraži polaske", to: "/" },
        ],
    },
    {
        slug: "kupovina-autobuskih-karata-online",
        date: "2026-10-07",
        title: "Kupovina autobuskih karata online: karta za autobus za par minuta",
        seoTitle: "Kupovina autobuskih karata online - brzo i sigurno | BusGo",
        seoDescription:
            "Kupovina autobuskih karata online na BusGo: pretražite polaske, uporedite cene i platite karticom. Karta u jednom smeru ili povratna, bez čekanja na šalteru.",
        excerpt:
            "Pretražite polaske više prevoznika, uporedite cene i kupite kartu u jednom smeru ili povratnu, bez odlaska na stanicu.",
        image: "/assets/news/kupovina-autobuskih-karata-online.jpg",
        imageAlt: "Pretraga autobuskih polazaka na BusGo sajtu na mobilnom telefonu",
        blocks: [
            {
                type: "p",
                text: "Kupovina autobuskih karata više ne mora da počne redom ispred šaltera. Na BusGo platformi polaske pretražujete, upoređujete i kupujete kartu sa računara ili telefona, kad vama odgovara.",
            },
            { type: "h2", text: "Zašto kupiti autobusku kartu online?" },
            {
                type: "p",
                text: "Kad kartu kupite unapred, mesto vam je obezbeđeno pre dolaska na stanicu. Ne zavisite od radnog vremena šaltera, a sve informacije o polasku imate na jednom mestu.",
            },
            {
                type: "ul",
                items: [
                    { lead: "Uštedite vreme.", text: "Kupovina traje par minuta, bez odlaska na stanicu." },
                    { lead: "Jasna cena.", text: "Cenu vidite pre plaćanja. Nema iznenađenja na šalteru." },
                    {
                        lead: "Sve na jednom mestu.",
                        text: "Na BusGo su polasci više prevoznika, pa ih upoređujete bez obilaska više sajtova.",
                    },
                    {
                        lead: "Karta uvek uz vas.",
                        text: "Kupljene karte se nalaze u vašem nalogu i stižu na vaš mejl.",
                    },
                ],
            },
            { type: "h2", text: "Kako izgleda kupovina autobuske karte na BusGo?" },
            {
                type: "ol",
                items: [
                    {
                        lead: "Pretražite polaske.",
                        text: "Unesite polazno mesto, odredište i datum putovanja. Za pretragu nije potreban nalog.",
                    },
                    {
                        lead: "Uporedite ponudu.",
                        text: "Za svaki polazak vidite vreme polaska i dolaska, prevoznika i cenu.",
                    },
                    { lead: "Izaberite vrstu karte.", text: "Kupite kartu u jednom smeru ili povratnu." },
                    {
                        lead: "Prijavite se i platite.",
                        text: "Kupovina se završava na vašem nalogu, a plaćate platnom karticom (VISA, Mastercard, Maestro, DinaCard) na zaštićenoj stranici za plaćanje.",
                    },
                    {
                        lead: "Gotovo.",
                        text: "Karta i fiskalni račun stižu na vaš mejl. Kartu možete videti i u delu „Moje karte\".",
                    },
                ],
            },
            { type: "h2", text: "Jedan smer ili povratna karta?" },
            {
                type: "p",
                text: "Ako znate da se vraćate, povratnu kartu kupite odmah i povratak vam je rešen unapred. Datum povratka ne birate pri kupovini. Povratnu kartu overite kad znate kojim polaskom se vraćate.",
            },
            { type: "h2", text: "Da li je online kupovina sigurna?" },
            {
                type: "p",
                text: "Podaci o platnoj kartici unose se isključivo na zaštićenoj stranici procesora platnih kartica Chip Card i nijednog trenutka nisu dostupni platformi BusGo. Za svaku kupovinu dobijate fiskalni račun, isto kao na šalteru.",
            },
            { type: "h2", text: "Saveti za putovanje autobusom" },
            {
                type: "ul",
                items: [
                    {
                        text: "Kartu kupite unapred u vreme praznika, vikenda i sezone, kad su polasci najtraženiji.",
                    },
                    { text: "Na stanicu dođite bar 15 minuta pre polaska." },
                    { text: "Proverite polazni peron i pripremite kartu na telefonu." },
                    { text: "Dolaske autobusa pratite na stranici „Dolasci\"." },
                ],
            },
            { type: "h2", text: "Kupite kartu za sledeće putovanje" },
            {
                type: "p",
                text: "Kupovina autobuskih karata na BusGo je brza, jednostavna i sigurna. Pretražite polaske, uporedite cene i krenite na put bez čekanja u redu.",
            },
            { type: "cta", text: "Pretraži polaske", to: "/" },
        ],
    },
];

export function findNews(slug) {
    return NEWS.find((item) => item.slug === slug) || null;
}
